import { Injectable } from '@angular/core';
import { HttpProviderService } from '@fpx/common/services';
import { map, Observable, of } from 'rxjs';
import { HttpRequestPayload, IHttpSuccessPayload } from '@fpx/core/models';

@Injectable({
  providedIn: 'root',
})
export class ShellService {
  private _workflowRowData: any | undefined;

  constructor(private _httpProvider: HttpProviderService) {}

  getTransactionRefNo() {}

  getDecisionButton() {
    /**get the decision button by passing  (service code and taskflowname ) as payload to api */
  }

  getApi(): Observable<any> {
    return of({});
  }

  updateDecision(payload: string, taskId: string, action: 'Complete') {
    const requestPayload: HttpRequestPayload = {
      method: 'POST',
      resource: `/user-task/${taskId}`,
      body: {
        data: payload,
      },
      headerParams: [
        {
          key: 'action',
          value: action,
        },
      ],
    };
    return this._httpProvider.invokeApi(requestPayload);
  }

  getworkflowdetail(workflowInstId: string): Observable<any> {
    const requestPayload: HttpRequestPayload = {
      method: 'GET',
      resource: '/getworkflowdetail',
      queryParams: [
        {
          key: 'category',
          value: 'stage',
        },
        {
          key: 'workflowInstId',
          value: workflowInstId,
        },
      ],
    };
    return this._httpProvider
      .invokeApi(requestPayload)
      .pipe(map((res: IHttpSuccessPayload<any[]>) => res.body));
  }

  public set workflowRowData(workflowData: any | undefined) {
    this._workflowRowData = workflowData;
  }

  public get workflowRowData(): any | undefined {
    return this._workflowRowData;
  }
}
